import React from 'react'
import PropTypes from 'prop-types'

class PhoneNumber extends React.Component {
   render() {
     const full = this.props.children
     const DDD = full.substr(0, 2)
     const numberFH = full.substr(2, 4)
     const numberSH = full.substr(6)
     return (
       <span>({DDD}) {numberFH}-{numberSH}</span>
     )
   }
 }
 PhoneNumber.propTypes = {
   children: PropTypes.string.isRequired,
 }
 
 export default PhoneNumber


// WEBPACK FOOTER //
// ./src/components/PhoneNumber/index.js